import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EmployeeDropdownResult } from 'app/models';
import { Utility } from 'app/shared';

@Component({
  selector: 'app-assign',
  templateUrl: './assign.component.html',
  styleUrls: ['./assign.component.scss']
})
export class AssignComponent {
  public utility = Utility;
  public toggle = false;

  @Input()
  public token: string = '';

  @Input()
  public assignedEmployeeId: number | null;

  @Input()
  public assignedEmployeePersonalPictureFileName: string;

  @Input()
  public assignedEmployeeFullName: string;

  @Input()
  public employeeDropdown: Array<EmployeeDropdownResult>;

  @Output()
  public employeeAssigned: EventEmitter<number>;

  constructor() {
    this.assignedEmployeeId = null;
    this.assignedEmployeeFullName = '';
    this.assignedEmployeePersonalPictureFileName = '';
    this.employeeAssigned = new EventEmitter<number>();
    this.employeeDropdown = new Array<EmployeeDropdownResult>();
  }

  public assigned(assignedEmployeeId: number | null): void {
    this.employeeAssigned.emit(assignedEmployeeId ?? 0);
  }

  public onChangeToggleClicked(): void {
    this.toggle = true;
  }
}
